import { useQuery } from '@tanstack/react-query';
import type { PaginatedOptimisationRunsDto, ListOptimisationRunsQuery } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface OptimisationRunsApiResponse {
  success: boolean;
  data: PaginatedOptimisationRunsDto;
}

export function useOptimisationRuns(query?: Partial<ListOptimisationRunsQuery>) {
  return useQuery({
    queryKey: queryKeys.optimisation.runs(query?.projectId),
    queryFn: async () => {
      const response = await apiClient.get<OptimisationRunsApiResponse>('/optimisation/runs', {
        params: query,
      });
      return response.data.data;
    },
  });
}
